import { defaultFormConfig } from '../../form/form/types/config';
export const defaultMemberFormConfig = Object.assign(Object.assign({}, defaultFormConfig), { cancelButton: Object.assign(Object.assign({}, defaultFormConfig.cancelButton), { show: false }) });
//# sourceMappingURL=config.js.map